import { GenerateLeadSubmissionPaymentLinkPayload } from "interfaces/lead-submission";

export type PartnerPaywallVariant = "partner";
export type PartnerActivateSurface = "default_activate" | "partner_paywall";

export type PartnerExperienceConfig = {
  activateSurface: PartnerActivateSurface;
  selfCampaignPlanName: GenerateLeadSubmissionPaymentLinkPayload["planName"];
  paywallVariant: PartnerPaywallVariant;
  paywallCtaLabel: string;
};

export const normalizePartnerIdentifier = (
  value?: string | null,
): string | undefined => {
  if (typeof value !== "string") {
    return undefined;
  }

  const normalized = value.trim().toLowerCase();
  return normalized.length > 0 ? normalized : undefined;
};

export const PARTNER_EXPERIENCES: Record<string, PartnerExperienceConfig> = {
  chowbus: {
    activateSurface: "partner_paywall",
    selfCampaignPlanName: "talk-town",
    paywallVariant: "partner",
    paywallCtaLabel: "Start My Free Campaign",
  },
};

export const getPartnerExperience = (
  partner?: string | null,
): PartnerExperienceConfig | undefined => {
  const normalized = normalizePartnerIdentifier(partner);
  if (!normalized) {
    return undefined;
  }

  return PARTNER_EXPERIENCES[normalized];
};
